import * as React from 'react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var name = "@pinwheel/react-modal";
var version = "2.4.5";
var description = "React package for Pinwheel modal";
var author = "roscioli";
var license = "MIT";
var repository = "underdog-tech/react-modal";
var main = "dist/index.js";
var module = "dist/index.modern.js";
var source = "src/index.tsx";
var engines = {
	node: ">=10"
};
var types = "dist/src/index.d.ts";
var scripts = {
	build: "rollup -c",
	lint: "eslint src --ext .ts,.tsx",
	start: "cd example && npm install && npm run start",
	test: "cd example && npm install && npm run test",
	predeploy: "cd example && npm install && npm run build",
	deploy: "gh-pages -d example/build"
};
var peerDependencies = {
	react: "^16.0.0 ||^17.0.2|| ^18.0.0"
};
var devDependencies = {
	"@babel/core": "^7.20.5",
	"@babel/preset-env": "^7.20.2",
	"@babel/preset-react": "^7.18.6",
	"@babel/preset-typescript": "^7.18.6",
	"@pinwheel/eslint-config": "^1.0.0-alpha.2",
	"@rollup/plugin-json": "^6.0.0",
	"@rollup/plugin-typescript": "^11.1.2",
	"@testing-library/jest-dom": "^5.16.5",
	"@testing-library/react": "^9.5.0",
	"@testing-library/user-event": "^7.2.1",
	"@types/jest": "^25.1.4",
	"@types/node": "^12.12.38",
	"@types/react": "^17.0.15",
	"@types/react-dom": "^17.0.9",
	"cross-env": "^7.0.2",
	"css-loader": "^6.7.2",
	eslint: "^8.28.0",
	jest: "^29.3.1",
	"jest-environment-jsdom": "^29.3.1",
	prettier: "^2.0.4",
	react: "^17.0.2",
	"react-dom": "^17.0.2",
	rollup: "^3.5.0",
	"rollup-plugin-import-css": "^3.1.0",
	"style-loader": "^3.3.1",
	"ts-loader": "^9.4.2",
	typescript: "^4.9.3",
	webpack: "^5.75.0",
	"webpack-cli": "^5.0.1",
	"webpack-dev-server": "^4.11.1"
};
var files = [
	"dist"
];
var packageJson = {
	name: name,
	version: version,
	description: description,
	author: author,
	license: license,
	repository: repository,
	main: main,
	module: module,
	source: source,
	engines: engines,
	types: types,
	scripts: scripts,
	peerDependencies: peerDependencies,
	devDependencies: devDependencies,
	files: files
};

var url = "https://cdn.getpinwheel.com/pinwheel-v2.3.11.js?sandbox=true";
var integrity = "sha512-NYgZ1R22gaRTXslvZwwktxkMiQ9WCz+RSCdxiwZdhYhdW7nD1kv0tR99/XXJAheSDgVUAQO1+WWTyIkwfWykMA==";
var portalConfig = {
	url: url,
	integrity: integrity
};

var _a = packageJson.version.split('.').map(Number), major = _a[0], minor = _a[1], patch = _a[2];
var SDK_VERSION = { major: major, minor: minor, patch: patch };
var PORTAL_URL = portalConfig.url, PORTAL_INTEGRITY = portalConfig.integrity;
var addScriptTag = function (loadCb, overrideUrl) {
    var tag = document.createElement('script');
    tag.async = true;
    tag.type = 'application/javascript';
    if (overrideUrl) {
        tag.src = overrideUrl;
    }
    else {
        tag.crossOrigin = 'anonymous';
        tag.integrity = PORTAL_INTEGRITY;
        tag.src = PORTAL_URL;
    }
    document.body.appendChild(tag);
    tag.addEventListener('load', function () { return loadCb(); });
    return tag;
};
var PinwheelModal = function (allProps) {
    var open = allProps.open, _srcUrl = allProps._srcUrl, props = __rest(allProps
    // Need to get _modalSessionIdOverride like this or else client using this module
    // with strict typescript typing will not be able to compile this without an error.
    // Error: "node_modules/@pinwheel/react-modal/dist/index.d.ts(85,48): error TS2339: Property '_modalSessionIdOverride' does not exist on type 'PinwheelModalProps'."
    , ["open", "_srcUrl"]);
    // Need to get _modalSessionIdOverride like this or else client using this module
    // with strict typescript typing will not be able to compile this without an error.
    // Error: "node_modules/@pinwheel/react-modal/dist/index.d.ts(85,48): error TS2339: Property '_modalSessionIdOverride' does not exist on type 'PinwheelModalProps'."
    var privateProps = allProps;
    var _modalSessionIdOverride = privateProps._modalSessionIdOverride, _sdkOverride = privateProps._sdkOverride;
    var _a = React.useState(false), loaded = _a[0], setLoaded = _a[1];
    var _b = React.useState(false), showing = _b[0], setShowing = _b[1];
    var _c = React.useState(), tag = _c[0], setTag = _c[1];
    React.useEffect(function () {
        // eslint-disable-next-line dot-notation
        delete window['Pinwheel'];
        setLoaded(false);
        var els = document.querySelectorAll('.pinwheel-portal');
        els.forEach(function (e) { var _a; return (_a = e.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(e); });
        var newTag = addScriptTag(function () { return setLoaded(true); }, _srcUrl);
        setTag(newTag);
    }, [_srcUrl, setLoaded]);
    React.useEffect(function () {
        if (tag && tag.parentNode)
            tag.parentNode.removeChild(tag);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_srcUrl]);
    React.useEffect(function () {
        if (!loaded)
            return;
        if (open && !showing) {
            Pinwheel.open(__assign(__assign({ _versionOverride: SDK_VERSION, _sdkOverride: _sdkOverride || 'react' }, props), { _modalSessionIdOverride: _modalSessionIdOverride }));
            setShowing(true);
        }
        else if (!open && showing) {
            Pinwheel.close();
            setShowing(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, showing, setShowing, loaded]);
    return React.createElement("div", null);
};

export { SDK_VERSION, PinwheelModal as default };
